import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import MenuComponent from "../components/dashboard/MenuComponent";
import SidebarComponent from "../components/dashboard/SidebarComponent";

export default function LayoutPage({children}) {
  return (
    <Container fluid className="d-flex flex-column vh-100">
      <Row className="bg-primary text-white">
        <MenuComponent />
      </Row>

      <Row className="flex-grow-1 d-flex">
        <Col
          lg={3}
          className="d-none d-md-block p-0"
          style={{ width: "250px" }}
        >
          <SidebarComponent/>
        </Col>

        <Col style={{height:'calc(100vh - 60px)',overflowY:'auto'}}>
          <div >
            {children}
          </div>
        </Col>
      </Row>
    </Container>
  );
}
